// The four seed contacts the 2019 app started with. Kept verbatim, including the
// placeholder text; `image` is an index into randomuser.me's portrait sets.
const description =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor " +
  "incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud " +
  "exercitation";

const contacts = [
  { id: 1, name: "Camila Terry", description, gender: "women", image: "50", favorite: false },
  { id: 2, name: "Joel Williamson", description, gender: "men", image: "42", favorite: true },
  { id: 3, name: "Deann Payne", description, gender: "women", image: "67", favorite: false },
  { id: 4, name: "Leona Hunte", description, gender: "women", image: "51", favorite: false }
];

export default contacts;
